<?xml version="1.0" encoding="UTF-8"?>
<svg width="30.45" height="30.45" id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 30.45 30.45">
  <!-- Generator: Adobe Illustrator 30.8.1, SVG Export Plug-In . SVG Version: 2.1.4 Build 1)  -->
  <defs>
    <style>
      .st0 {
        fill: #ffb3d9;
      }

      .st1 {
        fill: #bb0095;
      }

      .st2 {
        fill: #ff3ed4;
      }

      .st3 {
        fill: #7b043d;
      }
    </style>
  </defs>
  <path class="st2" d="M30.45,15.23C24.23,11.02,19.16,5.94,15.23,0v15.23h15.23Z"/>
  <path class="st0" d="M15.23,0C11.29,5.94,6.22,11.02,0,15.23h15.23V0Z"/>
  <path class="st1" d="M0,15.23c6.22,4.21,11.29,9.29,15.23,15.23v-15.23H0Z"/>
  <path class="st3" d="M15.23,15.23v15.23c3.94-5.94,9-11.02,15.23-15.23h-15.23Z"/>
</svg>
